import { getDepartmentAndPerson, getDepartment, getRoleInfo } from '@/api/workflow';
import { getMenuTree, getMenuTreeByRelationId } from '@/components/personDepartmentRoleSelect/util';
export default {
  data () {
    return {
      visibleDialog: false,
      searchVal: '',
      activeName: '1',
      departments: {},
      roles: []
    };
  },
  methods: {
    async getDepartmentAndPersonList (selected) {
      const selectGroupIds = [];
      const res = await getDepartmentAndPerson();
      const { code, data } = res.data;
      if (code == 200) {
        this.selectList = [...selected];
        const ids = selected.map((item) => item.id);
        this.selectedIds = ids;
        const { departments, users } = data;
        const userData = users.map(item => {
          const { departmentId, userId, realName, relationId, ...rest } = item;
          return {
            ...rest,
            id: userId,
            title: realName || item.userName,
            pid: departmentId,
            checked: ids.includes(userId),
            isGroup: false,
            groupRelationId: relationId
          };
        });
        const departmentData = departments.map(item => {
          const {
            childDepartmentId,
            childDepartmentName,
            departmentId,
            ...rest
          } = item;
          const currentUsers = userData.filter(
            user => user.pid == childDepartmentId
          );
          const checked =
            currentUsers.length > 0 &&
            currentUsers.every(user => user.checked);
          if (checked) {
            selectGroupIds.push(item.childDepartmentId);
          }
          return {
            ...rest,
            id: childDepartmentId,
            title: childDepartmentName,
            pid: departmentId,
            isGroup: true,
            checked
          };
        });

        const originData = [...departmentData, ...userData];
        const treeData = getMenuTreeByRelationId(originData);
        this.originData = originData;
        this.list = [...treeData];
        this.customTreeList = [...treeData];
      }
    },
    async getDepartmentList (selectData = []) {
      const selected = selectData || [];
      const res = await getDepartment();
      const { code, data } = res.data;
      if (code == 200) {
        this.selectList = [...selected];
        const ids = selected.map((item) => item.relationId);
        const dataMap = data.map(item => {
          const { childDepartmentId, childDepartmentName, departmentId, ...rest } = item;
          return {
            ...rest,
            id: childDepartmentId,
            title: childDepartmentName,
            pid: departmentId,
            toggleOpen: false,
            active: false,
            level: 0,
            checked: ids.includes(item.relationId)
          };
        });
        const list = getMenuTree(dataMap);
        this.list = list;
        this.customTreeList = [...list];
      }
    },
    async getRoleList ({ selected = [], id }) {
      const selectGroupIds = [];
      const res = await getRoleInfo(id);
      const { code, data } = res.data;
      if (code == 200) {
        this.selectList = [...selected];
        const ids = selected.map(item => item.id);
        const { roleGroupVoList: groupData, roleList } = data;
        const mapRole = roleList.map(role => {
          const { roleName, roleGroupId, ...rest } = role;
          return {
            ...rest,
            pid: roleGroupId,
            title: roleName,
            checked: ids.includes(role.id),
            isGroup: false
          };
        });
        const mapGroup = groupData.map(group => {
          const { roleGroupName, ...rest } = group;
          const currentUsers = mapRole.filter(
            user => user.pid == group.id
          );
          const checked =
            currentUsers.length > 0 &&
            currentUsers.every(user => user.checked);
          if (checked) {
            selectGroupIds.push(group.id);
          }
          return {
            ...rest,
            pid: null,
            title: roleGroupName,
            isGroup: true,
            checked
          };
        });
        this.selectGroupIds = selectGroupIds;
        const originData = [...mapGroup, ...mapRole];
        const treeData = getMenuTree(originData);
        this.originData = originData;
        this.list = [...treeData];
        this.customTreeList = [...treeData];
      }
    }
  }
};
